"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || (function () {
    var ownKeys = function(o) {
        ownKeys = Object.getOwnPropertyNames || function (o) {
            var ar = [];
            for (var k in o) if (Object.prototype.hasOwnProperty.call(o, k)) ar[ar.length] = k;
            return ar;
        };
        return ownKeys(o);
    };
    return function (mod) {
        if (mod && mod.__esModule) return mod;
        var result = {};
        if (mod != null) for (var k = ownKeys(mod), i = 0; i < k.length; i++) if (k[i] !== "default") __createBinding(result, mod, k[i]);
        __setModuleDefault(result, mod);
        return result;
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
const jsx_runtime_1 = require("react/jsx-runtime");
const react_1 = __importStar(require("react"));
const TitleBar_1 = require("./components/TitleBar/TitleBar");
const ServerList_1 = require("./components/ServerList/ServerList");
const ChannelSidebar_1 = require("./components/ChannelSidebar/ChannelSidebar");
const ChatHeader_1 = require("./components/ChatHeader/ChatHeader");
const MessageList_1 = require("./components/MessageList/MessageList");
const MessageInput_1 = require("./components/MessageInput/MessageInput");
const VoiceSessionView_1 = require("./components/VoiceSessionView");
const useStore_1 = require("./store/useStore");
const MemberList_1 = require("./components/MemberList/MemberList");
const UserProfilePanel_1 = require("./components/UserProfilePanel/UserProfilePanel");
const SplashScreen_1 = require("./components/SplashScreen/SplashScreen");
const lucide_react_1 = require("lucide-react");
const Settings_1 = require("./components/Settings/Settings");
const ServerSettings_1 = require("./components/Settings/ServerSettings");
const Discovery_1 = require("./components/Discovery/Discovery");
const Auth_1 = require("./components/Auth/Auth");
const FriendsPanel_1 = require("./components/FriendsPanel/FriendsPanel");
const LockScreen_1 = require("./components/LockScreen/LockScreen");
const UpdateManager_1 = require("./components/UpdateManager/UpdateManager");
const InviteModal_1 = require("./components/InviteModal/InviteModal");
const ServerInviteShareModal_1 = require("./components/InviteModal/ServerInviteShareModal");
const ServerConnectionOverlay_1 = require("./components/ServerConnectionOverlay/ServerConnectionOverlay");
const MultiTabOverlay_1 = require("./components/MultiTabOverlay/MultiTabOverlay");
const IncomingCallModal_1 = require("./components/IncomingCallModal/IncomingCallModal");
const DeveloperPortal_1 = require("./components/DeveloperPortal/DeveloperPortal");
const realtimeSync_1 = require("./services/realtimeSync");
require("./App.css");
const App = () => {
    const { currentUser, checkAuth, voiceViewVisible, fetchServers, settingsOpen, serverSettingsOpen, setSettingsOpen, setServerSettingsOpen, discoveryOpen, selectedDMUserId, selectedServerId, selectedChannelId, servers, setSelectedServer, setSelectedChannel, isVersionBlocked, membersPanelOpen, toggleMembersPanel, mobileSidebarOpen, setMobileSidebarOpen, voiceConnection, voiceViewChannelId, fetchFriends } = (0, useStore_1.useStore)();
    const isElectron = typeof window !== 'undefined' && !!window.require;
    const [showSplash, setShowSplash] = (0, react_1.useState)(() => {
        // Only show splash screen once on electron desktop app, never delay web browser
        if (!isElectron)
            return false;
        return typeof sessionStorage !== 'undefined' ? !sessionStorage.getItem('meci_splash_shown') : false;
    });
    const [isCheckingAuth, setIsCheckingAuth] = (0, react_1.useState)(true);
    const [developerOpen, setDeveloperOpen] = (0, react_1.useState)(() => {
        if (typeof window !== 'undefined') {
            return window.location.pathname.startsWith('/developer') || window.location.hash.startsWith('#developer');
        }
        return false;
    });
    react_1.default.useEffect(() => {
        const handleOpenDev = () => setDeveloperOpen(true);
        const handlePopState = () => {
            setDeveloperOpen(window.location.pathname.startsWith('/developer') || window.location.hash.startsWith('#developer'));
        };
        window.addEventListener('meci:open-developer-portal', handleOpenDev);
        window.addEventListener('popstate', handlePopState);
        return () => {
            window.removeEventListener('meci:open-developer-portal', handleOpenDev);
            window.removeEventListener('popstate', handlePopState);
        };
    }, []);
    react_1.default.useEffect(() => {
        (0, realtimeSync_1.initRealtimeSync)();
        const init = async () => {
            // Tema başlatma - Varsayılan: Cyberpunk Titanyum
            let savedTheme = localStorage.getItem('meci_theme');
            if (!savedTheme || savedTheme === 'blood-red') {
                savedTheme = 'cyberpunk';
                localStorage.setItem('meci_theme', 'cyberpunk');
            }
            document.documentElement.setAttribute('data-theme', savedTheme);
            await checkAuth();
            setIsCheckingAuth(false);
        };
        init();
    }, [checkAuth]);
    // Dynamic Realtime Friends Sync (runs every 4 seconds without refreshing the page)
    react_1.default.useEffect(() => {
        if (!currentUser)
            return;
        const interval = setInterval(() => {
            fetchFriends();
        }, 4000);
        return () => clearInterval(interval);
    }, [currentUser, fetchFriends]);
    // Track page view and navigation in analytics
    react_1.default.useEffect(() => {
        if (typeof window === 'undefined')
            return;
        const track = () => {
            try {
                const payload = JSON.stringify({
                    page_path: window.location.pathname + window.location.search + window.location.hash,
                    referrer: document.referrer || '',
                    screen_resolution: `${window.screen.width}x${window.screen.height}`,
                    device_type: isElectron ? 'Electron Desktop' : (/Mobi|Android|iPhone/i.test(navigator.userAgent) ? 'Mobil Web' : 'Masaüstü Web')
                });
                const url = `${(0, useStore_1.getApiBaseUrl)()}/analytics/pageview`;
                if (navigator.sendBeacon) {
                    navigator.sendBeacon(url, new Blob([payload], { type: 'application/json' }));
                }
                else {
                    fetch(url, { method: 'POST', headers: { 'Content-Type': 'application/json' }, body: payload, credentials: 'include' }).catch(() => { });
                }
            }
            catch (e) { }
        };
        track();
        window.addEventListener('popstate', track);
        return () => window.removeEventListener('popstate', track);
    }, [selectedServerId, selectedChannelId, selectedDMUserId]);
    const isProcessingOAuth = react_1.default.useRef(false);
    // Global Google & Flexable OAuth listener
    react_1.default.useEffect(() => {
        if (typeof window !== 'undefined') {
            const handleFlexableMsg = (event) => {
                if (event.data?.type === 'MECI_FLEXABLE_CONNECTED') {
                    if (!useStore_1.useStore.getState().currentUser) {
                        useStore_1.useStore.getState().loginWithFlexable(event.data).catch((err) => {
                            console.error('Flexable login error:', err);
                        });
                    }
                }
            };
            window.addEventListener('message', handleFlexableMsg);
            if (!isProcessingOAuth.current) {
                let codeOrToken = null;
                if (window.location.search) {
                    const params = new URLSearchParams(window.location.search);
                    const flexableToken = params.get('flexable_token');
                    const flexableCode = params.get('flexable_code');
                    if (flexableToken || flexableCode) {
                        isProcessingOAuth.current = true;
                        window.history.replaceState(null, '', window.location.pathname);
                        useStore_1.useStore.getState().loginWithFlexable({ accessToken: flexableToken, code: flexableCode }).catch(console.error);
                        return () => window.removeEventListener('message', handleFlexableMsg);
                    }
                    codeOrToken = params.get('code');
                }
                if (!codeOrToken && window.location.hash) {
                    const params = new URLSearchParams(window.location.hash.replace('#', '?'));
                    codeOrToken = params.get('access_token') || params.get('id_token');
                }
                if (codeOrToken) {
                    isProcessingOAuth.current = true;
                    window.history.replaceState(null, '', window.location.pathname);
                    useStore_1.useStore.getState().loginWithGoogle(codeOrToken).catch((err) => {
                        console.error('Google login error:', err);
                        isProcessingOAuth.current = false;
                    });
                }
            }
            return () => window.removeEventListener('message', handleFlexableMsg);
        }
    }, []);
    react_1.default.useEffect(() => {
        if (currentUser) {
            fetchServers();
            useStore_1.useStore.getState().fetchUsers();
        }
    }, [currentUser, fetchServers]);
    // ── Heartbeat System ─────────────────────────────────────────────────────────
    // Determines current screen label for activity tracking
    const getActiveScreen = (0, react_1.useCallback)(() => {
        const state = useStore_1.useStore.getState();
        if (state.voiceViewVisible || state.voiceConnection.channelId)
            return 'voice';
        if (state.discoveryOpen)
            return 'discovery';
        if (state.settingsOpen)
            return 'settings';
        if (state.serverSettingsOpen)
            return 'server-settings';
        if (state.selectedDMUserId)
            return 'dm';
        if (state.selectedServerId && state.selectedChannelId)
            return 'chat';
        if (state.selectedServerId)
            return 'server';
        return 'home';
    }, []);
    const sendActivityHeartbeat = (0, react_1.useCallback)((reason) => {
        if (!useStore_1.useStore.getState().currentUser)
            return;
        const state = useStore_1.useStore.getState();
        const isBackground = typeof document !== 'undefined' && document.visibilityState === 'hidden';
        const activeChannelId = state.voiceConnection.channelId || state.voiceViewChannelId || state.selectedChannelId;
        const activeServerId = state.selectedServerId;
        const activeScreen = getActiveScreen();
        // Fire-and-forget heartbeat
        (async () => {
            try {
                const { getDeviceInfo: _gdi, ...rest } = await Promise.resolve().then(() => __importStar(require('./store/useStore')));
            }
            catch { /* ignore */ }
            // Use the global API_BASE_URL via useStore internals
            const { API_BASE_URL: apiBase } = await Promise.resolve().then(() => __importStar(require('./store/useStore'))).then(m => {
                const s = m;
                return { API_BASE_URL: s.API_BASE_URL || '' };
            }).catch(() => ({ API_BASE_URL: '' }));
        })();
        // Actually call the exported heartbeat util
        window.__meciHeartbeat?.({
            active_screen: activeScreen,
            active_channel_id: activeChannelId,
            active_server_id: activeServerId,
            is_background: isBackground,
            login_method: reason || 'Heartbeat',
        });
    }, [getActiveScreen]);
    // Expose heartbeat fn to window for cross-module access
    react_1.default.useEffect(() => {
        // We call checkAuth which internally calls auth/me – re-use it for heartbeat
        window.__meciHeartbeat = (ctx) => {
            useStore_1.useStore.getState().sendHeartbeat(ctx);
        };
        return () => { delete window.__meciHeartbeat; };
    }, []);
    // 156-second periodic heartbeat
    react_1.default.useEffect(() => {
        if (!currentUser)
            return;
        const interval = setInterval(() => {
            sendActivityHeartbeat('Auto Heartbeat');
        }, 156000);
        return () => clearInterval(interval);
    }, [currentUser, sendActivityHeartbeat]);
    // Heartbeat on visibility change (foreground/background)
    react_1.default.useEffect(() => {
        if (!currentUser)
            return;
        const onVisibility = () => {
            sendActivityHeartbeat(document.visibilityState === 'hidden' ? 'Background' : 'Foreground');
        };
        document.addEventListener('visibilitychange', onVisibility);
        return () => document.removeEventListener('visibilitychange', onVisibility);
    }, [currentUser, sendActivityHeartbeat]);
    // Heartbeat on screen/channel change
    react_1.default.useEffect(() => {
        if (!currentUser)
            return;
        sendActivityHeartbeat('Navigation');
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [selectedServerId, selectedChannelId, selectedDMUserId, discoveryOpen, voiceViewVisible]);
    // Discord / Topluyo URL Sync & Cleaning (/index.html removal & /:serverId/:channelSlug support)
    react_1.default.useEffect(() => {
        if (typeof window === 'undefined' || !currentUser)
            return;
        // 1. Remove /index.html from URL path if present
        let currentPath = window.location.pathname;
        if (currentPath.endsWith('/index.html') || currentPath.includes('/index.html')) {
            currentPath = currentPath.replace('/index.html', '') || '/';
            window.history.replaceState(null, '', currentPath + window.location.search + window.location.hash);
        }
        // 2. Sync State -> URL
        if (discoveryOpen) {
            if (currentPath !== '/discovery') {
                window.history.pushState(null, '', '/discovery');
            }
        }
        else if (selectedDMUserId) {
            const dmPath = `/channels/@me/${selectedDMUserId}`;
            if (currentPath !== dmPath) {
                window.history.pushState(null, '', dmPath);
            }
        }
        else if (selectedServerId) {
            const server = servers.find((s) => String(s.id) === String(selectedServerId));
            const channel = server?.channels?.find((c) => String(c.id) === String(selectedChannelId));
            const channelSlug = channel ? (channel.name ? channel.name.toLowerCase().trim().replace(/\s+/g, '-') : channel.id) : '';
            // Ses kanalındaysak 3. segment olarak ses kanalı ID'si eklenir (bağlantıya dokunulmaz, sadece URL)
            const activeVoiceId = voiceConnection.channelId && !String(voiceConnection.channelId).startsWith('dm_')
                ? String(voiceConnection.channelId)
                : '';
            let targetPath = channelSlug ? `/${selectedServerId}/${channelSlug}` : `/${selectedServerId}`;
            if (activeVoiceId) {
                targetPath = channelSlug
                    ? `${targetPath}/${activeVoiceId}`
                    : `/${selectedServerId}/_/${activeVoiceId}`;
            }
            if (currentPath !== targetPath) {
                window.history.pushState(null, '', targetPath);
            }
        }
        else if (currentPath !== '/' && currentPath !== '/channels/@me') {
            window.history.pushState(null, '', '/channels/@me');
        }
    }, [currentUser, selectedServerId, selectedChannelId, selectedDMUserId, discoveryOpen, servers, voiceConnection.channelId]);
    // Handle URL navigation on initial load & popstate (Back/Forward)
    const voiceUrlJoinedRef = react_1.default.useRef(false);
    react_1.default.useEffect(() => {
        if (typeof window === 'undefined' || !currentUser || servers.length === 0)
            return;
        const parseAndApplyUrl = () => {
            const pathParts = window.location.pathname.replace(/^\/+|\/+$/g, '').split('/');
            if (pathParts.length >= 2 && pathParts[0] !== 'channels' && pathParts[0] !== 'discovery') {
                const urlServerId = pathParts[0];
                const urlChannelSlug = pathParts[1];
                const targetServer = servers.find((s) => String(s.id) === String(urlServerId));
                if (targetServer) {
                    const targetChannel = targetServer.channels?.find((c) => String(c.id) === String(urlChannelSlug) ||
                        (c.name && c.name.toLowerCase().trim().replace(/\s+/g, '-') === urlChannelSlug.toLowerCase()));
                    if (targetServer.id !== selectedServerId) {
                        setSelectedServer(targetServer.id);
                    }
                    if (targetChannel && targetChannel.id !== selectedChannelId) {
                        setSelectedChannel(targetChannel.id);
                    }
                    // 3. segment: ses kanalı ID'si. Henüz bağlı değilsek sayfa açılışında bir kez bağlan.
                    const urlVoiceId = pathParts[2];
                    if (urlVoiceId && !voiceUrlJoinedRef.current) {
                        const voiceCh = targetServer.channels?.find((c) => String(c.id) === String(urlVoiceId) && c.type === 'voice');
                        if (voiceCh) {
                            voiceUrlJoinedRef.current = true;
                            const vs = useStore_1.useStore.getState();
                            if (!vs.voiceConnection.channelId) {
                                vs.joinVoiceChannel(voiceCh.id);
                            }
                        }
                    }
                }
            }
        };
        parseAndApplyUrl();
        window.addEventListener('popstate', parseAndApplyUrl);
        return () => window.removeEventListener('popstate', parseAndApplyUrl);
    }, [currentUser, servers]);
    // Deep Link & Web URL Invite Listener
    react_1.default.useEffect(() => {
        if (typeof window === 'undefined')
            return;
        // 1. Web URL invite extraction (?invite=CODE, ?code=CODE, /invite/CODE, #/invite/CODE)
        const extractInviteCode = () => {
            // Query parameters
            if (window.location.search) {
                const params = new URLSearchParams(window.location.search);
                const code = params.get('invite') || params.get('code');
                if (code && code.trim().length >= 5)
                    return code.trim();
            }
            // Pathname (e.g. /invite/xyz or /pc/invite/xyz)
            const path = window.location.pathname || '';
            if (path.includes('/invite/')) {
                const parts = path.split('/invite/');
                const code = parts[parts.length - 1].replace(/\/$/, '').split('?')[0];
                if (code && code.trim().length >= 5)
                    return code.trim();
            }
            // Hash (e.g. #/invite/xyz or #invite=xyz)
            if (window.location.hash) {
                const hash = window.location.hash;
                if (hash.includes('invite/')) {
                    const parts = hash.split('invite/');
                    const code = parts[parts.length - 1].replace(/\/$/, '').split('?')[0];
                    if (code && code.trim().length >= 5)
                        return code.trim();
                }
                const params = new URLSearchParams(hash.replace(/^#\/?/, '?'));
                const code = params.get('invite') || params.get('code');
                if (code && code.trim().length >= 5)
                    return code.trim();
            }
            return null;
        };
        const webInviteCode = extractInviteCode();
        if (webInviteCode) {
            useStore_1.useStore.getState().setPendingInviteCode(webInviteCode);
        }
        // 2. Electron custom protocol listener (meci://invite/CODE)
        if (window.require) {
            try {
                const electron = window.require('electron');
                if (electron && electron.ipcRenderer) {
                    const handleDeepLink = (_event, url) => {
                        if (url.includes('invite/')) {
                            const parts = url.split('invite/');
                            const code = parts[parts.length - 1].replace(/\/$/, '');
                            if (code && code.length >= 5) {
                                useStore_1.useStore.getState().setPendingInviteCode(code);
                            }
                        }
                    };
                    electron.ipcRenderer.on('deep-link', handleDeepLink);
                    return () => {
                        electron.ipcRenderer.removeListener('deep-link', handleDeepLink);
                    };
                }
            }
            catch (e) { }
        }
    }, []);
    // ESC ile ayarları kapat
    react_1.default.useEffect(() => {
        const handleEsc = (e) => {
            if (e.key === 'Escape') {
                if (settingsOpen)
                    setSettingsOpen(false);
                if (serverSettingsOpen)
                    setServerSettingsOpen(false);
            }
        };
        window.addEventListener('keydown', handleEsc);
        return () => window.removeEventListener('keydown', handleEsc);
    }, [settingsOpen, setSettingsOpen, serverSettingsOpen, setServerSettingsOpen]);
    if (showSplash) {
        return (0, jsx_runtime_1.jsx)(SplashScreen_1.SplashScreen, { onFinish: () => setShowSplash(false) });
    }
    if (isCheckingAuth) {
        return ((0, jsx_runtime_1.jsx)("div", { className: "app-loading", children: (0, jsx_runtime_1.jsx)(lucide_react_1.LucideLoader2, { className: "animate-spin", size: 48, color: "var(--brand-primary)" }) }));
    }
    if (isVersionBlocked && isElectron) {
        return (0, jsx_runtime_1.jsx)(UpdateManager_1.UpdateManager, {});
    }
    if (!currentUser) {
        return (0, jsx_runtime_1.jsx)(Auth_1.Auth, {});
    }
    if (developerOpen) {
        return ((0, jsx_runtime_1.jsx)(DeveloperPortal_1.DeveloperPortal, { onBack: () => {
                setDeveloperOpen(false);
                if (typeof window !== 'undefined' && (window.location.pathname.startsWith('/developer') || window.location.hash.startsWith('#developer'))) {
                    window.history.pushState(null, '', '/');
                }
            } }));
    }
    return ((0, jsx_runtime_1.jsxs)("div", { className: "app", children: [(0, jsx_runtime_1.jsx)(ServerConnectionOverlay_1.ServerConnectionOverlay, {}), (0, jsx_runtime_1.jsx)(MultiTabOverlay_1.MultiTabOverlay, {}), (0, jsx_runtime_1.jsx)(LockScreen_1.LockScreen, {}), (0, jsx_runtime_1.jsx)(TitleBar_1.TitleBar, {}), !isVersionBlocked && (0, jsx_runtime_1.jsx)(UpdateManager_1.UpdateManager, {}), (0, jsx_runtime_1.jsxs)("div", { className: "app-container", children: [mobileSidebarOpen && ((0, jsx_runtime_1.jsx)("div", { className: "mobile-sidebar-backdrop active", onClick: () => setMobileSidebarOpen(false) })), (0, jsx_runtime_1.jsxs)("div", { className: `app-sidebar-drawer ${mobileSidebarOpen ? 'mobile-open' : ''}`, children: [(0, jsx_runtime_1.jsx)(ServerList_1.ServerList, {}), (0, jsx_runtime_1.jsx)(ChannelSidebar_1.ChannelSidebar, {})] }), discoveryOpen ? ((0, jsx_runtime_1.jsx)(Discovery_1.Discovery, {})) : ((0, jsx_runtime_1.jsxs)(jsx_runtime_1.Fragment, { children: [(0, jsx_runtime_1.jsx)("div", { className: "main-content", children: voiceViewVisible ? ((0, jsx_runtime_1.jsx)(VoiceSessionView_1.VoiceSessionView, {})) : selectedDMUserId ? ((0, jsx_runtime_1.jsxs)(jsx_runtime_1.Fragment, { children: [(0, jsx_runtime_1.jsx)(ChatHeader_1.ChatHeader, { channelType: "dm" }), (0, jsx_runtime_1.jsx)(MessageList_1.MessageList, { isDM: true }), (0, jsx_runtime_1.jsx)(MessageInput_1.MessageInput, { isDM: true })] })) : !selectedServerId ? ((0, jsx_runtime_1.jsx)(FriendsPanel_1.FriendsPanel, {})) : ((0, jsx_runtime_1.jsxs)(jsx_runtime_1.Fragment, { children: [(0, jsx_runtime_1.jsx)(ChatHeader_1.ChatHeader, {}), (0, jsx_runtime_1.jsx)(MessageList_1.MessageList, {}), (0, jsx_runtime_1.jsx)(MessageInput_1.MessageInput, {})] })) }), selectedServerId && membersPanelOpen && ((0, jsx_runtime_1.jsxs)(jsx_runtime_1.Fragment, { children: [(0, jsx_runtime_1.jsx)("div", { className: "mobile-members-backdrop active", onClick: () => toggleMembersPanel() }), (0, jsx_runtime_1.jsx)("div", { className: "members-drawer-container", children: (0, jsx_runtime_1.jsx)(MemberList_1.MemberList, {}) })] }))] }))] }), (0, jsx_runtime_1.jsx)(IncomingCallModal_1.IncomingCallModal, {}), (0, jsx_runtime_1.jsx)(UserProfilePanel_1.UserProfilePanel, {}), (0, jsx_runtime_1.jsx)(Settings_1.Settings, {}), (0, jsx_runtime_1.jsx)(ServerSettings_1.ServerSettings, {}), (0, jsx_runtime_1.jsx)(InviteModal_1.InviteModal, {}), (0, jsx_runtime_1.jsx)(ServerInviteShareModal_1.ServerInviteShareModal, {})] }));
};
exports.default = App;
